import { render, staticRenderFns } from "./RoutePanelForDriver.vue?vue&type=template&id=48863870&scoped=true"
import script from "./RoutePanelForDriver.vue?vue&type=script&lang=js"
export * from "./RoutePanelForDriver.vue?vue&type=script&lang=js"
import style0 from "./RoutePanelForDriver.vue?vue&type=style&index=0&id=48863870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48863870",
  null
  
)

export default component.exports